import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import Atividade from "model/gestao/atividades/Atividade";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import AtividadeService from "service/gestao/atividades/AtividadeService";

const atividadeService = new AtividadeService();

export default function AtividadeCadastro() {

    const { setError, formState: { errors }, register, clearErrors} = useForm();

    useEffect(() => {
    }, [])

    const [atividade, setAtividade] = useState<Atividade>(new Atividade());

    function validar() {

        if (!atividade.nome) {
            setError("nome", {type: "manual", message: "Nome é obrigatório"}, {shouldFocus: true})
            return false;
        }

        return true;
    }

    return (

        <BaseCadastro model={atividade} service={atividadeService} setModel={(value: Atividade) => setAtividade(value)} validar={() => validar()} urlService="/atividade" pathCadastro="/atividade" tituloPagina={'Atividade'}>

            <div style={{ display: "flex" }}>
                <Checkbox
                    checked={atividade.cobranca}
                    onChange={(e) => { setAtividade({ ...atividade, cobranca: e.checked as boolean }) }}
                    style={{ marginRight: 5 }}
                />
                <label>Tem cobrança?</label>
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText required value={atividade.nome} style={{ width: '100%' }} 
                        className={errors.nome ? "p-invalid" : ""}
                        {...register("nome",{
                            onChange: (e) => {
                                clearErrors("nome");
                                setAtividade({ ...atividade, nome: e.target.value })
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>
        </BaseCadastro>
    )
}
